import { Ionicons } from '@expo/vector-icons';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Divider } from 'react-native-paper';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useBottomSheet } from '@/contexts/bottomSheetContext';
import { i18n } from '@/utils/i18n';

import LightRatingButton from '../buttons/LightRatingButton';
import Text from '../Text';

interface LightRatingBottomSheetProps {
  churchName: string;
  lightRatingValue: number;
}

const LightRatingBottomSheet = ({ churchName, lightRatingValue }: LightRatingBottomSheetProps) => {
  const dispatch = useBottomSheet().dispatch;

  const closeSheet = () => {
    dispatch({ type: 'SET_VISIBLE', setVisible: false });
  };

  // Strings
  const lightRatingFooter = i18n.t('light_rating_bottom_sheet.footer');
  const lightRating = i18n.t('mix.light_rating');

  return (
    <SafeAreaView style={styles.mainContainer} edges={['bottom']}>
      <View style={styles.mainContainer}>
        <View style={styles.headerSection}>
          <View style={styles.header}>
            <TouchableOpacity onPress={closeSheet} style={styles.closeButton}>
              <Ionicons size={24} name="close" style={styles.closeIcon} />
            </TouchableOpacity>

            <Text style={styles.headerTitle} fontWeight="900">
              {lightRating}
            </Text>
          </View>

          <Divider />
        </View>

        <View style={styles.content}>
          <Text fontWeight="900" style={styles.churchName}>
            {churchName}
          </Text>
          <LightRatingButton variant="xlarge" lightRatingValue={lightRatingValue} disabled />
          <Text style={styles.footerText}>{lightRatingFooter}</Text>
        </View>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1
  },

  headerSection: {
    flexDirection: 'column',
    justifyContent: 'center',
    paddingHorizontal: 18
  },

  header: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingBottom: 25
  },

  headerTitle: {
    alignSelf: 'flex-end',
    fontSize: 18,
    color: 'black'
  },

  closeButton: {
    position: 'absolute',
    left: 0
  },

  closeIcon: {
    color: 'black',
    backgroundColor: '#F4F4F4',
    borderWidth: 1,
    borderColor: '#EDEDED',
    borderRadius: 26 / 2,
    overflow: 'hidden'
  },

  content: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 25,
    paddingHorizontal: 18,
    paddingVertical: 25
  },

  churchName: {
    color: 'black',
    fontSize: 20
  },

  lightRatingMainContainer: {
    zIndex: 1
  },

  lightRatingContent: {
    flexDirection: 'column',
    alignItems: 'center'
  },

  lightRatingFlameIcon: {
    height: 65,
    width: 65,
    zIndex: 3
  },

  lightRatingValue: {
    fontSize: 40,
    color: 'black',
    zIndex: 3
  },

  footerText: {
    flex: 1,
    paddingHorizontal: 36,
    textAlign: 'center'
  },

  learnMore: {
    color: '#BB822D'
  }
});

export default LightRatingBottomSheet;
